import moment from "moment";

// source as defined in WorkOrderEntryModel
export default function CreateWorkOrderModel(source) {
  const model = {
    name: `${source.categoryName} at ${source.siteName}`, // Name of WorkOrder
    customer: source.customerId, // Customer (Client) reference
    territory: source.territoryId, // Territory reference

    site: source.siteId,
    type: source.type, // WorkOrder Type
    workordercategory: source.category, // WorkOrder category reference
    workordersubcategory: source.subCategory, // WorkOrder subcategory reference. The PPM WorkOrder category doesn't require a SubCategory
    description: source.faultDescription, // Description of WorkOrder
    reportername: source.reportername, // Person who reported issue
    ponumber: source.ponumber, // Optional Purchase Order number
    property: source.propertyId, // Property reference
    createdon: source.createdon, // When the WorkOrder was created, ISO-8601 format datetime

    customername: source.customername, // Occupier name
    customerphone: source.customerphone, // Occupier phone number
    customeremail: source.customeremail, // Occupier email, must be XXX@YYYY.ZZZ format. SV reject if it's not a valid email format but haven't specified what regex they're using...
    customervulnerability: source.customervulnerability, // Optional occupier vulnerability
    diagnosis: source.diagnosis, // Diagnosis steps taken by Sw2 staff on phone
    slahours: source.slahours, // Number of hours to respond

    // Not yet implemented on PUT
    reportertype: source.reportertype,
    reporteremail: source.reporteremail,
    reporterphone: source.reportertelephone,
    agreedoutsidesla: Boolean(source.agreedoutsidesla),

    // When the WorkOrder should be started by, ISO-8601 format datetime
    // Use preferred appointment date if possible
    startby: source.preferredAppointmentDate
      ? moment(source.preferredAppointmentDate).toISOString()
      : null,

    idempotencyGuid: source.idempotencyGuid,
  };

  // If preferredAppointmentDate is empty startby will be null.
  // startby is a required field to create a work order so calculate from slahours.
  // If slahours is empty just use now.
  if (!model.startby) {
    if (model.slahours) {
      model.startby = moment().add(model.slahours, "hours").toISOString();
    } else {
      model.startby = moment().toISOString();
    }
  }

  // Exclude asset property if "Unknown" asset is specified
  if (source.asset && source.asset !== "Unknown") {
    model.asset = source.asset;
  }

  return model;
}
